// Robust clipboard copy — navigator.clipboard.writeText() can silently reject in real
// browsers when called after an async gap (e.g. an API call) since it's no longer treated
// as "in direct response to a user gesture". Falls back to a hidden textarea + execCommand.
export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch {
      return false;
    }
  }
};
